import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { Calendar, Users, LayoutDashboard, Settings as SettingsIcon, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_unified-calendar-app-2/artifacts/7wohqirg_Texto%20del%20pa%CC%81rrafo.jpeg";

export default function AppLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const nav = [
    { to: "/app", label: "Resumen", icon: LayoutDashboard, end: true, testid: "nav-dashboard" },
    { to: "/app/calendario", label: "Agenda", icon: Calendar, testid: "nav-calendar" },
    { to: "/app/pacientes", label: "Clientas", icon: Users, testid: "nav-patients" },
    { to: "/app/configuracion", label: "Configuración", icon: SettingsIcon, testid: "nav-settings" },
  ];

  return (
    <div className="min-h-screen flex bg-[#F4EFE4]">
      {/* Sidebar */}
      <aside className="w-64 border-r border-[#E8DFD2] bg-white flex flex-col">
        <div className="px-6 py-6 border-b border-[#E8DFD2]">
          <div onClick={() => navigate("/app")} className="flex items-center gap-3 cursor-pointer" data-testid="app-logo">
            <img src={LOGO_URL} alt="Amarme" className="w-11 h-11 rounded-full object-cover border border-[#B5704A]/20" />
            <div className="leading-tight">
              <div className="brand-wordmark text-sm text-[#3A2418]">AMARME</div>
              <div className="font-script text-xs text-[#B5704A] -mt-0.5">Skin</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 px-3 py-6 space-y-1">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={item.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-[#B5704A] text-white"
                    : "text-[#6F5A4C] hover:bg-[#E8DFD2]/40 hover:text-[#3A2418]"
                }`
              }
            >
              <item.icon className="w-4 h-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-[#E8DFD2]">
          <div className="flex items-center gap-3 p-2">
            <Avatar className="w-9 h-9">
              <AvatarImage src={user?.picture} alt={user?.name} />
              <AvatarFallback className="bg-[#E8DFD2] text-[#3A2418] text-xs">{user?.name?.[0]?.toUpperCase()}</AvatarFallback>
            </Avatar>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-[#3A2418] truncate" data-testid="user-name">{user?.name}</div>
              <div className="text-xs text-[#6F5A4C] truncate">{user?.email}</div>
            </div>
            <button
              onClick={logout}
              className="p-2 rounded-md text-[#6F5A4C] hover:bg-[#FAF7F1] hover:text-[#B5704A] transition-colors"
              title="Cerrar sesión"
              data-testid="logout-button"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
